module.exports = __webpack_public_path__ + "img/hiking.be5030ca.webp";